// activityNewUser6
export default {
  routerTitle: '盈宝新人礼',
  shareTitle: '盈宝新人礼 奖金高达2900HKD',
  shareDesc: '奖励升级 千元礼包等你拿',

  or: '或',
  award: '奖',
  awardAgain: '再奖',
  awardAgain2: '可获奖励共',
  cashCoupons: '现金券',

  cardOneLabel1: '注册送行情',
  cardOneValue11: '内地客户送30天港股LV2行情券',
  cardOneValue12: '完成美股非专业订户问卷送30天美股LV1行情',
  cardOneDesc1: '注：香港及海外地区送港股LV1行情',
  cardOneLabel2: '开户送 HKD 2256 礼包',
  cardOneValue21: '30天港股LV2串流报价行情',
  cardOneValue22: '完成美股非专业订户问卷送30天美股LV1行情',
  cardOneDesc2: '注：香港及海外地区港股送30天LV1行情，美股送30天美股LV1行情',

  cardTwoTitle: '首次入金2万(或等值)以上最高赠送 HKD 600 礼包',
  cardTwoTable1: '首次入金 HKD 20,000 - 299,999(或等值)',
  cardTwoTable1Row: '30天内无出金且成交股票一次',
  cardTwoTable2: '首次入金 HKD 20,000 - 299,999(或等值)',
  cardTwoTable2Row: '60天内无出金且成交股票一次',
  cardTwoTable3: '首次入金 HKD 20,000 - 299,999(或等值)',
  cardTwoTable3Row: '90天内无出金且成交股票一次',

  cardThreeTitle: '首次入金30万(或等值)以上最高赠送 HKD 2900 礼包',
  cardThreeTable1: '首次入金 HKD 30万(或等值) 以上',
  cardThreeTable1Row1: '30天内无出金且成交股票一次',
  cardThreeTable2: '交易额达标奖励',
  cardThreeTable2Row11: '30天内无出金',
  cardThreeTable2Row12: '且交易额达到150万(或等值)',
  cardThreeTable2Row21: '60天内无出金',
  cardThreeTable2Row22: '且交易额达到300万(或等值)',
  cardThreeTable2Row31: '90天内无出金',
  cardThreeTable2Row32: '且交易额达到450万(或等值)',

  pageTips: '注：首次入金2万奖励和首次入金30万奖励只能参与一个。'
}
